import './Login.css';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { httpsCallable } from 'firebase/functions';
import { signOut } from 'firebase/auth';
import { auth, functions } from '../services/firebase';

export default function Onboarding({ onDone }) {
  const { t } = useTranslation();
  const [accountName, setAccountName] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const create = async () => {
    if (!accountName.trim()) return;
    setError('');
    setLoading(true);
    try {
      const provisionAccount = httpsCallable(functions, 'provisionAccount');
      await provisionAccount({ accountName, name });
      await onDone();
    } catch (err) {
      console.error(err);
      setError(t('auth.errors.signup'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-brand">
          <svg viewBox="0 0 32 32" aria-hidden="true">
            <rect width="32" height="32" rx="8" fill="#16C47F" />
            <path d="M8 8h16a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-6l-5 4v-4H8a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3z" fill="#07241A" />
          </svg>
          Yunoo <span className="login-chip">ADMIN</span>
        </div>
        <h2>{t('auth.onboardingTitle')}</h2>
        <p className="login-sub">{t('auth.onboardingSubtitle')}</p>
        <input className="field" placeholder={t('auth.businessName')} value={accountName} onChange={e => setAccountName(e.target.value)} />
        <input className="field" placeholder={t('auth.yourName')} value={name} onChange={e => setName(e.target.value)} />
        {error && <p className="login-error">{error}</p>}
        <button className="btn btn-primary login-submit" onClick={create} disabled={loading}>
          {loading ? t('auth.creating') : t('auth.createAccount')}
        </button>
        <p className="login-alt">
          {t('auth.notYou')} <button type="button" onClick={() => signOut(auth)}>{t('common.logout')}</button>
        </p>
      </div>
    </div>
  );
}
